import { Component, ChangeDetectionStrategy, OnInit } from '@angular/core'
import { Router, Event as RouterEvent, RouteConfigLoadStart } from '@angular/router'
import { Store, Observable, AppFields } from '../../store'

@Component({
  selector: 'app-shiawan-app',
  templateUrl: 'app.com.html',
  styleUrls: ['app.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class AppComponent implements OnInit {

  loading: Observable<boolean>

  constructor(private store: Store<any>, private router: Router) {}

  ngOnInit() {
    this.loading = Observable.combineLatest(
      this.store.select(AppFields.App, AppFields.Loading).map(Boolean),
      this.router.events.map((e: RouterEvent) => e instanceof RouteConfigLoadStart),
      (loading: boolean, routing: boolean) => loading || routing
    )
  }

}



// WEBPACK FOOTER //
// ./src/app/com/app/app.com.ts